import { Flash } from '@acast/decibel';
import T from 'prop-types';
import React from 'react';

const createErrorMessage = (key, error) => {
  if (key === 'custom') {
    return error;
  }

  const keyName =
    {
      linkUrl: 'link URL',
      videoUrl: 'video URL',
    }[key] || key;

  return `The ${keyName} is invalid.`;
};

const Errors = ({ errors }) => {
  if (!errors) return null;

  return (
    <Flash intent="danger">
      {Object.keys(errors).map(key => (
        <React.Fragment key={key}>{createErrorMessage(key, errors[key])}</React.Fragment>
      ))}
    </Flash>
  );
};

Errors.propTypes = {
  errors: T.object,
};

export default Errors;
